/**
 * Detection window presets. Start (live) / Fetch (single-shot) run from
 * `now - windowMs`; a live rule's first tick backfills that whole span, then
 * subsequent ticks ride the live edge. Windows are relative-only.
 */
const HOUR = 3_600_000;

/** Quick-pick relative window sizes shown as chips on every rule card. */
export const REPLAY_PRESETS: { label: string; ms: number }[] = [
  { label: '1h', ms: HOUR },
  { label: '5h', ms: 5 * HOUR },
  { label: '12h', ms: 12 * HOUR },
  { label: '3d', ms: 3 * 24 * HOUR },
  { label: '7d', ms: 7 * 24 * HOUR },
];

/** Default window when the operator hasn't picked one: 1h. */
export const DEFAULT_PRESET_MS = HOUR;
